import React, { useEffect, useState } from 'react'
import { Typography, Button, TextArea, TextField, CheckBox, IconButton, Fab, DatePicker, Select } from '../../ui/core'
import { Add, Delete } from '../../ui/coreIcons'
import { v4 as uuidv4 } from 'uuid';
import ServiceOrganisations from '../../../services/organisation';
import ServiceDepartment from '../../../services/department';

import { Delete as DeleteIcon } from '../../ui/coreIcons';
export default function Index({ survey, onSave, onCopy }) {
    const [item, setItem] = useState()
    const [params, setParams] = useState([]);
    const [organisations, setOrganisations] = useState([]);
    const [departments, setDepartments] = useState([]);
    const [lastDepartment, setLastDepartment] = useState();

    useEffect(() => {
        let tmpItem = Object.assign({}, survey);
        if (!tmpItem.mainProcesses) { tmpItem.mainProcesses = []; }
        if (!tmpItem.subProcesses) { tmpItem.subProcesses = []; }
        if (!tmpItem.colorRange) { tmpItem.colorRange = [] }
        setItem(tmpItem)
        ServiceOrganisations.get()
            .then(organisations => {
                setOrganisations(organisations.filter(org => { return org.active === true }))
                if (survey.template === true) {
                    let arrDepartments = [];
                    organisations.forEach(org => {
                        arrDepartments.push(ServiceDepartment.getForOrganisation(org._id))
                    })
                    Promise.all(arrDepartments)
                        .then(departments => {
                            let allDepartments = [];
                            departments.forEach(dep => {
                                allDepartments = allDepartments.concat(dep.filter(d => { return d.active === true }))
                            })
                            setDepartments(allDepartments);
                        })
                        .catch(ex => { setDepartments([]) })
                }
            })

        ServiceOrganisations.get(survey.organisation)
            .then(organisation => { setParams(organisation.params || []) })
            .catch(ex => { setParams([]) })

    }, [survey])

    useEffect(() => {
        if (item && item.forOrganisation) {
            /*
            if (lastDepartment !== item.forOrganisation) {
                setLastDepartment(item.forOrganisation)
                ServiceDepartment.getForOrganisation(item.forOrganisation || '0')
                    .then(departments => {
                        setDepartments(departments.filter(dep => { return dep.active === true }))
                    })
                    .catch(ex => { setDepartments([]) })
            }
                    */
        }
    }, [item])

    const handleChange = (attribute, value) => {
        let tmpItem = Object.assign({}, item);
        tmpItem[attribute] = value;
        setItem(tmpItem);
    }

    const handleSave = () => {
        let tmpItem = Object.assign({}, item);
        onSave(tmpItem);
    }


    const handleChangeAndSave = (attribute, value) => {
        let tmpItem = Object.assign({}, item);
        tmpItem[attribute] = value;
        setItem(tmpItem);
        onSave(tmpItem);

    }

    const handleChangeDate = (date) => {
        let tmpItem = Object.assign({}, item);
        tmpItem.date = date;
        setItem(tmpItem);
        onSave(tmpItem);
    }

    const addMainProcess = () => {
        let tmpItem = Object.assign({}, item);
        tmpItem.mainProcesses.push({ _id: uuidv4(), title: 'Hoofd proces ..', code: '', active: true });
        setItem(tmpItem);
        onSave(tmpItem);
    }

    const changeMainProcess = (process, attribute, value) => {
        let tmpItem = Object.assign({}, item);
        let found = tmpItem.mainProcesses.find(t => { return t._id === process._id })
        if (found) {
            found[attribute] = value;
        }
        setItem(tmpItem);
    }

    const deleteMainProcess = (process) => {
        if (window.confirm('Weet u zeker dat u dit process wilt verwijderen?')) {
            let tmpItem = Object.assign({}, item);
            let found = tmpItem.mainProcesses.find(t => { return t._id === process._id })
            if (found) {
                found.active = false;
            }
            setItem(tmpItem);
            onSave(tmpItem);
        }
    }

    const addSubProcess = (process) => {
        let tmpItem = Object.assign({}, item);
        let found = tmpItem.mainProcesses.find(t => { return t._id === process._id })
        if (found) {
            if (!found.subProcesses) found.subProcesses = [];
            found.subProcesses.push({ _id: uuidv4(), title: 'Sub proces ..', code: '', active: true });
        }

        setItem(tmpItem);
    }



    const changeSubProcess = (process, attribute, value) => {
        let tmpItem = Object.assign({}, item);
        for (let i = 0; i < tmpItem.mainProcesses.length; i++) {
            if (tmpItem.mainProcesses[i].subProcesses) {
                let found = tmpItem.mainProcesses[i].subProcesses.find(t => { return t._id === process._id })
                if (found) {
                    found[attribute] = value;
                }
            }
        }

        setItem(tmpItem);
    }

    const deleteSubProcess = (process) => {
        let result = window.confirm('Weet u zeker dat u dit process wilt verwijderen?');
        if (result) {
            let tmpItem = Object.assign({}, item);
            for (let i = 0; i < tmpItem.mainProcesses.length; i++) {
                if (tmpItem.mainProcesses[i].subProcesses) {
                    let found = tmpItem.mainProcesses[i].subProcesses.find(t => { return t._id === process._id })

                    if (found) {
                        found.active = false;
                    }
                }
            }
            setItem(tmpItem);
            onSave(tmpItem);
        }

    }

    const handleChangeCheckParam = (param, checked) => {
        let tmpItem = Object.assign({}, item);
        if (!tmpItem.params) tmpItem.params = [];
        if (tmpItem.params.indexOf(param._id) >= 0) {
            tmpItem.params.splice(tmpItem.params.indexOf(param._id), 1)
        }
        if (checked) {
            tmpItem.params.push(param._id)
        }

        setItem(tmpItem);
        onSave(tmpItem);
    }

    const handleDeleteSurvey = () => {
        if (window.confirm('Weet u zeker dat u dit wilt verwijderen?')) {
            let tmpItem = Object.assign({}, item);
            tmpItem.active = false;
            setItem(tmpItem);
            onSave(tmpItem);
        }

    }

    const addColorRange = (process) => {
        let tmpItem = Object.assign({}, item);

        tmpItem.colorRange.push({ _id: uuidv4(), from: 0, to: 100, color: '#00698f', active: true });
        setItem(tmpItem);
    }

    const handleChangeColorRange = (range, attribute, value) => {
        let tmpItem = Object.assign({}, item);
        let found = tmpItem.colorRange.find(r => { return r._id === range._id });
        if (found) {
            found[attribute] = value;
            setItem(tmpItem);
            onSave(tmpItem);
        }
    }

    const handleDeleteColorRange = (range) => {
        if (window.confirm('Weet u zeker dat u dit wilt verwijderen?')) {
            let tmpItem = Object.assign({}, item);
            tmpItem.colorRange = tmpItem.colorRange.filter(r => { return r._id !== range._id })
            setItem(tmpItem);
            onSave(tmpItem);
        }
    }

//  <DatePicker value={survey.date} showTimeSelect={true} onChange={handleChangeDate} />
    if (!item) return null;
    return (
        <>
            <div style={{ display: 'flex', flexDirection: 'row', }}>
                <div style={{ flex: 1, paddingRight: '20px' }}>
                    <Typography component="h3">Titel</Typography>
                    <TextField id="title" value={item.title} onChange={(ev) => { handleChange('title', ev.target.value); }} onBlur={handleSave}></TextField>

                </div>
                <div style={{ flex: 1, paddingRight: '20px' }}>
                    {survey.template !== true && <>
                        <Typography component="h3">Uitvoerdatum/tijd evaluatie</Typography>
                            <TextField 
                                id="date" 
                                type="datetime-local" 
                                value={item.date ? new Date(item.date).toISOString().slice(0, 16) : ''} 
                                onChange={(ev) => { handleChange('date', ev.target.value); }} 
                                onBlur={handleSave}
                            />

                      
                        <br />
                    </>}
                </div>
            </div>

            {survey.template === true && <>
                <br />   <br />
                <div className="label">Publiceren</div>
                <CheckBox id="published" label="Vragenlijst is beschikbaar" checked={item.published || false} onChange={(ev) => { handleChangeAndSave('published', ev.target.checked) }} />

                <div className="label">Archiveren (wanneer dit item is gearchiveerd kan deze vragenlijst niet meer worden geselecteerd voor een evaluatie)</div>
                <CheckBox id="archived" label="In archief plaatsen" checked={item.archived || false} onChange={(ev) => { handleChangeAndSave('archived', ev.target.checked) }} />
              
                <div className="label">Beschikbaar voor</div>
                <CheckBox id="forAll" label="Voor alle organisaties" checked={item.forAll || false} onChange={(ev) => { handleChangeAndSave('forAll', ev.target.checked) }} />
                {item.forAll !== true && <table>
                    <tbody>
                        {organisations.filter(org=>{return org.archived !== true}).map(org => {
                            return <tr key={org._id}>
                                <td valign='top'><CheckBox id={'forOrg_' + org._id} label={org.name} checked={item.forOrganisations && item.forOrganisations.indexOf(org._id) >= 0} onChange={(ev) => { handleChangeAndSave('forOrganisations', ev.target.checked ? [...(item.forOrganisations || []), org._id] : (item.forOrganisations || []).filter(o => { return o !== org._id })) }} /></td>
                                <td>{(item.forOrganisations && item.forOrganisations.indexOf(org._id) >= 0) && departments.filter(dep=>{return dep.archived !== true}).filter(dep => { return dep.organisation === org._id }).map(dep => {
                                    return <CheckBox key={'forDep_' + dep._id} id={'forDep_' + dep._id} label={dep.name} checked={item.forDepartments && item.forDepartments.indexOf(dep._id) >= 0} onChange={(ev) => { handleChangeAndSave('forDepartments', ev.target.checked ? [...(item.forDepartments || []), dep._id] : (item.forDepartments || []).filter(d => { return d !== dep._id })) }} />
                                })}</td>
                            </tr>
                        })}
                    </tbody>
                </table>
                }
                {
                    /*
                       <Select id="forOrganisation" label="Voor organisatie" value={item.forOrganisation} onChange={(ev) => { handleChangeAndSave('forOrganisation', ev.target.value) }}>
                    <option value="0">Alle organisaties</option>
                    {organisations.map(org => { return <option key={org._id} value={org._id}>{org.name}</option> })}
                </Select>
                <Select id="forDepartment" label="Voor afdeling" value={item.forDepartment} onChange={(ev) => { handleChangeAndSave('forDepartment', ev.target.value) }}>
                    <option value="0">Alle afdelingen</option>
                    {departments.map(dep => { return <option key={dep._id} value={dep._id}>{dep.name}</option> })}
                </Select>
                    */
                }
             
            </>}

            {survey.forevaluation === true && <>
                {params.length > 0 && <>
                    <Typography component="h3">Parameters</Typography>
                    Selecteer de parameters die van toepassing zijn voor deze evaluatie<br /><br />
                    {params.filter(p => { return p.active === true }).map(param => {
                        return <CheckBox key={'cb_par_' + param._id} id={'par_' + param._id} label={param.name || ''} checked={item.params && item.params.indexOf(param._id) >= 0} onChange={(ev) => handleChangeCheckParam(param, ev.target.checked)} />

                    })}
                </>}

                <br />

                <div >
                    <Typography component="h3">Hoofdprocessen</Typography>
                    <table style={{ width: '100%' }}><tbody>
                        {item.mainProcesses.filter(p => { return p.active === true }).length > 0 && <tr><td className="label">Titel</td><td className="label">Code</td><td></td></tr>}
                        {item.mainProcesses.filter(p => { return p.active === true }).map((process) => {
                            let tmpRow =
                                <tr key={process._id}>
                                    <td valign="top" ><TextField id={process._id + 'title'} value={process.title} onChange={(ev) => { changeMainProcess(process, 'title', ev.target.value) }} onBlur={() => { onSave(item) }} /></td>
                                    <td valign="top" ><TextField id={process._id + 'code'} value={process.code} onChange={(ev) => { changeMainProcess(process, 'code', ev.target.value) }} onBlur={() => { onSave(item) }} /></td>
                                    <td valign="top"  ><IconButton onClick={() => { deleteMainProcess(process) }}><Delete /></IconButton></td>
                                    <td valign="top">
                                        <table><tbody>
                                            {process.subProcesses && process.subProcesses.filter(p => { return p.active === true }).length > 0 && <tr><td className="label">Titel subproces</td><td className="label">Code subproces</td><td></td></tr>}
                                            {process.subProcesses && process.subProcesses.filter(p => { return p.active === true }).map(subProcess => {
                                                return <tr key={subProcess._id}>
                                                    <td valign="top" ><TextField id={subProcess._id + 'title'} value={subProcess.title} onChange={(ev) => { changeSubProcess(subProcess, 'title', ev.target.value) }} onBlur={() => { onSave(item) }} /></td>
                                                    <td valign="top" ><TextField id={subProcess._id + 'code'} value={subProcess.code} onChange={(ev) => { changeSubProcess(subProcess, 'code', ev.target.value) }} onBlur={() => { onSave(item) }} /></td>
                                                    <td valign="top"  ><IconButton onClick={() => { deleteSubProcess(subProcess) }}><Delete /></IconButton></td>
                                                </tr>
                                            })}
                                        </tbody></table>
                                        <Button style={{ float: 'right' }} onClick={() => addSubProcess(process)} >Toevoegen subproces</Button>
                                    </td>
                                </tr>
                            return tmpRow
                        })}
                    </tbody></table>
                    <Button onClick={addMainProcess} style={{ float: 'right' }} variant="outlined">Toevoegen hoofdproces</Button>
                    <br /><br />

                </div>

                <Typography component="h3">Kleurweergave scores</Typography>
                <table style={{ width: '100%' }}><tbody>
                    <tr><td className="label">van (%)</td><td className="label">tot (%)</td><td className="label">verwoording</td><td className="label">kleurcode</td><td></td></tr>
                    {item.colorRange.map(range => {
                        return <tr key={range._id}>
                            <td><TextField type="number" id={range._id + 'from'} value={range.from || 0} onChange={(ev) => { handleChangeColorRange(range, 'from', ev.target.value) }} onBlur={() => { onSave(item) }} /></td>
                            <td><TextField type="number" id={range._id + 'to'} value={range.to} onChange={(ev) => { handleChangeColorRange(range, 'to', ev.target.value) }} onBlur={() => { onSave(item) }} /></td>
                            <td><TextField id={range._id + 'text'} value={range.text} onChange={(ev) => { handleChangeColorRange(range, 'text', ev.target.value) }} onBlur={() => { onSave(item) }} /></td>
                            <td style={{ backgroundColor: range.color }}><TextField id={range._id + 'color'} value={range.color} onChange={(ev) => { handleChangeColorRange(range, 'color', ev.target.value) }} onBlur={() => { onSave(item) }} /></td>
                            <td valign="top"  ><IconButton onClick={() => { handleDeleteColorRange(range) }}><Delete /></IconButton></td>
                        </tr>
                    })}
                </tbody></table>
                <Button onClick={addColorRange}>Toevoegen kleur</Button>


            </>}

            <br /><br />
            <Button onClick={onCopy} variant="contained" >Kopieer {survey.title} naar een nieuwe vragenlijst</Button>   <br /><br />
            <Button onClick={handleDeleteSurvey} style={{ backgroundColor: '#ff6A13' }} variant="contained" startIcon={<DeleteIcon color="white" />}>Verwijder {survey.title}</Button>


            <br />


        </>
    )
}
